<template>
	<headerSearch></headerSearch>
	<div class="w1440 personal_center">
		<div class="flex-box col90 ptb10 page_location">
			当前位置：
			<router-link class="col04" to="/BaseInfo">
				用户中心
				<span class="plr5">/</span>
			</router-link>
			<div class="now_page">发票管理</div>
		</div>
		<div class="flex-box flex-col-start">
			<personal-nav :firstIndex="3" :secondIndex="-1"></personal-nav>
			<div class="ml10 flex-grow-1 part_r">
				<div class="title_box flex-box flex-between fs18">
					<div class="col90">发票详情</div>
					<div class="back col12 cursor flex-box" @click="pageBack">返回</div>
				</div>
				<div class="wait_box flex-box flex-center flex-col" v-if="isLoading">
					<img src="../../../assets/static/icon/c_invoice_wait.png" class="icon_wait mb25" alt="" />
					<div class="fs18 colc9">图片正在加载中，请稍等片刻</div>
				</div>
				<iframe :src="pdfSource" frameborder="0" style="width:100%;height:600px;"></iframe>
				<!-- <vue-pdf-embed :style="`opacity:${isLoading ? 0 : 1}`" :source="pdfSource" :page="page" annotation-layer text-layer @loaded="handleDocumentLoad" @rendered="handleDocumentRender" @error="onPdfError" /> -->
			</div>
		</div>
	</div>
</template>
<script>
	import VuePdfEmbed from "vue-pdf-embed";
	import PersonalNav from "../../../components/PersonalNav.vue";
	import { useHead } from "@unhead/vue";
	import { onMounted } from "vue";
	export default {
		setup() {
			onMounted(() => {
				useHead({
					title: "发票管理-小狮优选",
					meta: [
						{ name: "description", content: "This is my page description" },
						{ property: "og:title", content: "My Page Title" },
						{ property: "og:description", content: "This is my page description" },
						{ property: "og:url", content: "https://example.com/my-page" },
						{ property: "og:image", content: "https://example.com/my-image.jpg" },
					],
					link: [{ rel: "canonical", href: "https://example.com/my-page" }],
				});
			});
		},
		components: {
			PersonalNav,
			VuePdfEmbed,
		},
		data() {
			return {
				url: "",
				isLoading: true,
				page: null,
				pageCount: null,
				// pdfSource: '',
				pdfSource: "https://vip.xiaoshiyouxuan.com/uploads/pdf/24312000000327643067.pdf",
				showAllPages: true,
			};
		},
		created() {
			// this.pdfSource = decodeURIComponent(this.$route.query.url);
		},
		watch: {
			showAllPages() {
				this.page = this.showAllPages ? null : 1;
			},
		},
		methods: {
			pageBack() {
				this.$router.go(-1);
			},
			handleDocumentLoad({ numPages }) {
				this.pageCount = numPages;
			},
			handleDocumentRender(e) {
				this.isLoading = false;
			},
			onPdfError(error) {
				console.error("PDF 加载错误:", error);
			},
		},
	};
</script>

<style lang="less" scoped>
	.part_r {
		padding: 41px 44px 57px;
		background: #fff;

		.title_box {
			padding-bottom: 25px;

			.back::before {
				content: "";
				display: block;
				width: 27px;
				height: 24px;
				background: url("/src/assets/static/icon/c_back.png") no-repeat center;
				background-size: 100%;
				margin-right: 10px;
			}
		}

		.wait_box {
			width: 1000px;
			height: 644px;
			background: #fbfcfd;

			.icon_wait {
				width: 104px;
				height: 84px;
				display: block;
			}
		}
	}
</style>
